const share = {
	$this: $( '.js-share' ),
	$link: $( '.js-open-share' ),
	$options: $( '.js-share-options' ),
};

share.init = function() {

	share.$link.on( 'click', function(e) {
		e.preventDefault();
		if ( share.$this.hasClass( 'is-active' ) ) {
			share.$this.removeClass( 'is-active' );
			setTimeout( function() {
				//share.$options.css( { visibility: 'hidden' } );
				share.$options.removeAttr( 'style' );
			}, 100 );
		} else {
			share.$options.css( { visibility: 'visible' } );
			setTimeout( function() {
				share.$this.addClass( 'is-active' )
			}, 100 );
			share.$this.icons();
		}
	} );
};

export { share };
